import React, { useEffect, useState, startTransition } from "react";
// import profileBanner from "../../Assets/images/profile-bnr.webp";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import { LanguageConstants } from "../../constants/LanguageConstants";
import Swal from 'sweetalert2'
import BrandedLoaderOverlay from "../layout/BrandedLoaderOverlay";
import { useResourceEverLoaded } from "../layout/useSmartBrandedLoader";
import "../layout/page-loading-shell.scss";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../constants/RouteConstants";
import { formatAddressBookRow } from "../myquotation/view-quotation/helpers";

const AddressList = () => {
  const List = useMakeRequest()
  const deleteAddress = useMakeRequest()
  const setPrimaryRequest = useMakeRequest()
  const [primaryAddressId, setPrimaryAddressId] = useState<any>(null)
  const navigate = useNavigate()

const [data , setData] = useState<any[]>([])
  useEffect(() => {
    List.makeRequest({url: ApiConstants?.AddressList, toastStatus: false })
  }, [deleteAddress.status])

  useEffect(() => {
    if (!setPrimaryRequest?.status) return
    List.makeRequest({ url: ApiConstants?.AddressList, toastStatus: false })
  }, [setPrimaryRequest?.status])

  useEffect(() => {
    if (!List?.status) return;
    startTransition(() => {
      const rows = List?.data?.data?.rows || [];
      setData(rows);
      if (rows?.length > 0) {
        const marked = rows.find((r: any) => Number(r?.is_primary) === 1 || String(r?.is_primary) === '1');
        const primaryId = marked?.id ?? rows[0]?.id;
        setPrimaryAddressId(primaryId);
      } else {
        setPrimaryAddressId(null);
      }
    });
  }, [List.status, List?.data?.data?.rows]);

  const handelDelete =(id:any)=>{
      Swal.fire({
        title: LanguageConstants?.ARE_YOU_SURE,
        text: LanguageConstants?.YOU_WANT_TO_DELETE_Address,
        icon: 'warning',
        // showCancelButton: true,
        confirmButtonColor: '#31CE36',
        cancelButtonColor: '#d33',
        showDenyButton: true,
        denyButtonText: 'No',
        confirmButtonText: LanguageConstants?.YES,
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          const payload ={
            address_id:id
          }
          deleteAddress.makeRequest({ payload, url: ApiConstants?.AddressDelete, toastStatus: true })
        }
      });
  }

  const handleUpdate =(data:any)=>{
    navigate(Routes.AddressEdit.replace(':id', String(data?.id)), {
      state: { address: data }
    })
  }

  const handleAddAddress = () => {
    navigate(Routes.AddressCreate)
  }

  const handleSetPrimary = (row: any) => {
    if (!row?.id) return
    setPrimaryRequest.makeRequest({
      payload: { address_id: row.id },
      url: ApiConstants?.AddressSetPrimary,
      toastStatus: true,
    })
  }

  const orderedAddresses = [...data].sort((a: any, b: any) => {
    if (a?.id === primaryAddressId) return -1
    if (b?.id === primaryAddressId) return 1
    return 0
  })

  const primaryAddress: any = orderedAddresses[0]
  const otherAddresses: any[] = orderedAddresses.slice(1)

  const addressListEverLoaded = useResourceEverLoaded(Boolean(List?.status));
  const initialAddressPending =
    !addressListEverLoaded && List.error == null && !List.status;
  const showAddressLoader =
    Boolean(deleteAddress?.loading) ||
    Boolean(setPrimaryRequest?.loading) ||
    initialAddressPending ||
    (List.loading && !addressListEverLoaded);
  const showPageContent = addressListEverLoaded || List.error != null;
  
  return (
    <>
    <BrandedLoaderOverlay active={showAddressLoader} immediate />
    {showPageContent ? (
        <div className="head-space page-loading-shell__content">
          <div className="inner-content">
            <div className="container">
              <div className="address-book-shell">
                <span className="address-book-badge">Address Book</span>
                {data?.length > 0 ? (
                  <>
                    <div className="address-list-panel">
                      <div className="address-list-panel__section px-3 pt-3">
                        <h3 className="address-list-panel__title">Primary</h3>
                        {primaryAddress ? (
                          <div className="address-row">
                            <span className="address-row__text">
                              {formatAddressBookRow(primaryAddress)}
                            </span>
                            <div className="address-row__actions">
                              <button type="button" className="address-row__action" onClick={() => handleUpdate(primaryAddress)}>Edit</button>
                              <span className="address-row__divider">|</span>
                              <button type="button" className="address-row__action" onClick={() => handelDelete(primaryAddress?.id)}>Remove</button>
                            </div>
                          </div>
                        ) : null}
                      </div>

                      {otherAddresses.length > 0 ? (
                        <div className="address-list-panel__section">
                          <h3 className="address-list-panel__title px-3 pt-3 mb-0">Other</h3>
                          <ul className="my-address-list">
                            {otherAddresses?.map((res:any) => (
                              <li className="address-item px-3" key={res?.id}>
                                <span className="address-row__text">
                                  {formatAddressBookRow(res)}
                                </span>
                                <div className="address-row__actions">
                                  <button type="button" className="address-row__action" onClick={() => handleUpdate(res)}>Edit</button>
                                  <span className="address-row__divider">|</span>
                                  <button type="button" className="address-row__action" onClick={() => handelDelete(res?.id)}>Remove</button>
                                  <span className="address-row__divider">|</span>
                                  <button type="button" className="address-row__action" onClick={() => handleSetPrimary(res)}>Set as Primary</button>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : null}
                    </div>
                    <div className="address-add-trigger-wrap">
                      <button type="button" className="address-add-trigger" onClick={handleAddAddress}>
                        <span className="address-add-trigger__icon" aria-hidden="true">+</span>
                        <span>Add New Address</span>
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="address-empty-state">
                    <p className="address-empty-state__message">
                      {LanguageConstants?.ADDRESS_EMPTY_STATE_MESSAGE}
                    </p>
                    <button type="button" className="address-add-trigger" onClick={handleAddAddress}>
                      <span className="address-add-trigger__icon" aria-hidden="true">+</span>
                      <span>Add New Address</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
    ) : null}
    </>
  );
};

export default AddressList;
